var app = angular.module("leonardo");

var ApprovalTaskController = function ($window, $scope, $q, $timeout, $state, $stateParams, $filter, BrowserHistoryService, approvalStepObj,
                                       AttachmentService, ngDialog, FilterService, PropertyService, ApprovalStepService,
                                       NoteService, DynamicFormRestService, DynamicFormDataRestService, TaskService,
                                       NavigationService, PermissionService, FolderFileService, FormErrorsService,
                                       NotificationService, AccountUserService, AnalyticsService, StatsigService, DynamicFormProviderService,
                                       AuthDataService) {

  $scope.loading = true;
  $scope.filterService = FilterService;
  $scope.approvalStepService = ApprovalStepService;
  $scope.TaskService = TaskService;
  $scope.permissionService = PermissionService;
  $scope.attachmentService = AttachmentService;
  $scope.data = {};
  $scope.dataEdit = {};
  $scope.attachments = [];
  $scope.attachments_note = [];
  $scope.notes = [];
  $scope.noteGroupExpanded = [];
  $scope.approvalStep = approvalStepObj;
  $scope.prev_step = null;
  $scope.current_step = null;
  $scope.next_step = null;
  $scope.initialdata = {};
  $scope.newState = {};
  $scope.taskGroupTrackingData = {}
  $scope.time_sensitive_options = [
    { id: true, name: $filter('translate')('Yes') },
    { id: false, name: $filter('translate')('No') },
  ];
  const placeholderNote = '<p>Add your comments here</p>\n';
  $scope.isFromSubmit = false

  $scope.OpenLogsPDF = function () {
    TaskService.getApprovalLogPDF($scope.approvalStep.id).then(function (url) {
      $window.open(url, '_blank');
    });
  }

  $scope.initData = function () {
    if (!$scope.approvalStep) {
      return NavigationService.goToTaskOverview();
    } else if ($scope.approvalStep.property) {
      var propertyId = $scope.approvalStep.property.id || $scope.approvalStep.property;
      var propertyInvalid = $filter('propertyName')(propertyId) === 'Invalid property';
      var currentPropertyId = (FilterService.currentProperty && FilterService.currentProperty.id) ? FilterService.currentProperty.id : FilterService.currentProperty;
      if ((propertyId !== currentPropertyId) && !propertyInvalid) {
        FilterService.setProperty($scope.approvalStep.property);
      }
    }
    if ($scope.approvalStep.current_step) {
      ApprovalStepService.get($scope.approvalStep.current_step.id).then(function (step) {
        $scope.current_step = step;
        $scope.data.text = step.notes.length === 0 ? '' : step.notes[0].text;
        $scope.attachments_note = step.notes.length === 0 ? [] : step.notes[0].attachments;
        openFormDialog(500);
      });
    } else {
      openFormDialog(100);
    }

    $scope.taskGroupTrackingData = {
      account: $scope.approvalStep.submitted_by.account,
      portfolio: $scope.approvalStep.portfolio.id,
      property: $scope.approvalStep.property.id,
      id: $scope.approvalStep.id,
      name: $scope.approvalStep.name,
      template: $scope.approvalStep.template.id
    }

    if($scope.approvalStep.workflow_instance && $stateParams.workflow) {
      $scope.taskGroupTrackingData.workflow_instance = $scope.approvalStep.workflow_instance;
      $scope.taskGroupTrackingData.workflow_instance['workflow'] = $stateParams.workflow;
    }
    $scope.comments = $scope.approvalStep.notes.slice(-1)[0];
    $scope.approver_notes = $scope.groupSteps($scope.approvalStep.reviewed_steps);
    if ($scope.approver_notes.length > 0) {
      $scope.noteGroupExpanded.push($scope.approver_notes[$scope.approver_notes.length - 1][0].approval_sequence);
    }
  };

  function openFormDialog(timespan) {
    $timeout(function () {
      if ($state.params.show_df && $scope.approvalStep.dynamic_form) {
        let editable = $scope.canEditDF();
        $scope.openDynamicFormDialog(editable);
      }
    }, timespan);
  }

  $scope.launchWorkflow = function (result) {
    var items_ids = [];
    angular.forEach(result.workflow_instance.active_templates, function (value) {
      items_ids.push(value.id);
    });
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/launch.html',
      controller: 'LaunchWorkFlowDialog',
      data: {
        workflow: result.workflow_instance,
        items: items_ids,
        property: result.property,
        unit: result.workflow_instance.unit ? result.workflow_instance.unit.id : null,
        workflow_id: result.workflow_instance.workflow,
        is_launch_trigger_wfs: true,
        is_mrb: $state.params.is_mrb,
        context: "Tasks Page"
      }
    }).then(function (){
      // This is intentional do_something blank function
    });
  };

  $scope.canEditDF = function () {
    if ([
      TaskService.STATUS_APPROVAL_IN_PROGRESS,
      TaskService.STATUS_APPROVAL_APPROVED,
      TaskService.STATUS_APPROVAL_REJECTED,
    ].includes($scope.approvalStep.status.toString())) {
      return $scope.approvalStep.can_review;
    } else {
      return $scope.approvalStep.editable;
    }
  }

  $scope.canEditSteps = function (step) {
    if (PermissionService.isOwner()) return true;
    var current_user = AccountUserService.currentAccountUser.user;
    let approversIds = [];
    let current_step = step || $scope.current_step;
    var approver = false;
    if (current_step && angular.isArray(current_step.user_approvers)) {
      current_step.user_approvers.map(user => {
        approversIdsList(user, approversIds);
      });
    }
    if (approversIds.length > 0) {
      angular.forEach(approversIds, function (step_approver) {
        if (current_user.id === step_approver) {
          approver = true;
        }
      })
    }
    return approver;
  }

  $scope.noteGroupIsExpanded = function (group_id) {
    return $scope.noteGroupExpanded?.includes(group_id);
  };

  $scope.toggleNoteGroup = function (group_id) {
    let index = $scope.noteGroupExpanded.indexOf(group_id);
    if (index >= 0) {
      $scope.noteGroupExpanded.splice(index, 1);
    } else {
      $scope.noteGroupExpanded.push(group_id);
    }
  }

  $scope.showInitialApprover = function (note) {
    return note?.action_by_user?.id !== note?.user_approvers[0]?.id;
  }

  $scope.getSequenceDates = function (notes) {
    let dates = [];
    if (notes.length > 0) {
      dates.push(moment(notes[0].action_date).format('MMM DD, YYYY'));
      let noteDate = moment(notes[notes.length - 1].action_date).format('MMM DD, YYYY');
      if (!dates.includes(noteDate)) {
        dates.push(noteDate);
      }
    }
    return dates.join(' - ');
  };

  $scope.getSequenceSteps = function () {
    var currentSequence = null;
    var currentStepIndex = -1;
    if (!$scope.approvalStep || !$scope.approvalStep.current_step || isEmpty($scope.approvalStep.approval_sequences)) {
      return;
    }
    angular.forEach($scope.approvalStep.approval_sequences, function (sequence){
      if (sequence.id === $scope.approvalStep.current_step.approval_sequence) {
        currentSequence = sequence;
      }
    });
    if (!currentSequence) {
      return;
    }
    angular.forEach(currentSequence.approval_steps, function (step, index) {
      if ($scope.approvalStep.current_step.id === step.id) {
        currentStepIndex = index;
      }
    });
    if (currentStepIndex >= 0) {
      $scope.prev_step = currentSequence.approval_steps[currentStepIndex-1] || null;
      $scope.next_step = currentSequence.approval_steps[currentStepIndex+1] || null;
    }
  };

  $scope.getCurrentApprovers = function (step, limit) {
    let approvers = [];
    let approversIds = [];
    let current_step = step || $scope.current_step;
    if (current_step && angular.isArray(current_step.user_approvers)) {
      current_step.user_approvers.map(user => {
        approversList(limit, user, approvers, approversIds);
      });
    }
    if (current_step && angular.isArray(current_step.secondary_user_approvers)) {
      current_step.secondary_user_approvers.map(user => {
        approversList(limit, user, approvers, approversIds);
      });
    }
    if (current_step && angular.isArray(current_step.secondary_user_approvers_by_role)) {
      current_step.secondary_user_approvers_by_role.map(user => {
        approversList(limit, user, approvers, approversIds);
      });
    }
    return approvers.join(', ');
  }

  $scope.getCurrentApproversLength = function (step) {
    let approversIds = [];
    let current_step = step || $scope.current_step;
    if (current_step && angular.isArray(current_step.user_approvers)) {
      current_step.user_approvers.map(user => {
        approversIdsList(user, approversIds);
      });
    }
    if (current_step && angular.isArray(current_step.secondary_user_approvers)) {
      current_step.secondary_user_approvers.map(user => {
        approversIdsList(user, approversIds);
      });
    }
    if (current_step && angular.isArray(current_step.secondary_user_approvers_by_role)) {
      current_step.secondary_user_approvers_by_role.map(user => {
        approversIdsList(user, approversIds);
      });
    }
    return approversIds.length;
  }

  function approversList(limit, user, approvers, approversIds) {
    if (!approversIds.includes(user.id) && (!limit || approversIds.length < limit)) {
      approversIds.push(user.id);
      approvers.push($filter('username')(user));
    }
  }

  function approversIdsList(user, approversIds) {
    if (!approversIds.includes(user.id)) {
      approversIds.push(user.id);
    }
  }

  $scope.getCurrentSequenceSteps = function () {
    let sequence_steps = 0;
    if (!isEmpty($scope.approvalStep.approval_sequences)) {
      angular.forEach($scope.approvalStep.approval_sequences, function (sequence) {
        if (sequence.id === $scope.current_step.approval_sequence) {
          sequence_steps = sequence.approval_steps.length;
        }
      });
    }
    return sequence_steps;
  };

  $scope.getCurrentStepIndex = function () {
      return $scope.current_step ? $scope.current_step.index + ' ' + $filter('translate')('of') + ' ' + $scope.getCurrentSequenceSteps() : ' - ';
    };

  $scope.isLastStepIndex = function () {
    return $scope.current_step.index == $scope.getCurrentSequenceSteps();
  };

  $scope.groupSteps = function (reviewed_steps) {
    const result = [];
    const steps = $filter('orderBy')(reviewed_steps, ['approval_sequence', 'index']);
    steps.forEach(revi_step => {
      switch (revi_step.status.toString()) {
        case ApprovalStepService.STATUS_APPROVED:
          revi_step.status_name = $filter('translate')('Approved');
          break;
        case ApprovalStepService.STATUS_REJECTED:
          revi_step.status_name = $filter('translate')('Terminated');
          break;
        case ApprovalStepService.STATUS_REVISION_REQUIRED:
          revi_step.status_name = $filter('translate')('Request for revision');
          break;
      }

      if (result[`sequence_${revi_step.approval_sequence}`]) {
        result[`sequence_${revi_step.approval_sequence}`].push(revi_step);
      } else {
        result[`sequence_${revi_step.approval_sequence}`] = [revi_step];
      }
    });
    return Object.values(result);
  }

  $scope.showEditApprovalDialog = function () {
    TaskService.one($scope.approvalStep.id).get({for_approval: true}).then(function (task) {
      var data = {
        approval_steps: []
      }
      if (task && !isEmpty(task.approval_sequences)) {
        angular.forEach(task.approval_sequences, function (sequence) {
          if (sequence.id === $scope.current_step.approval_sequence) {
            data.approval_steps = $filter('orderBy')(angular.copy(sequence.approval_steps), 'index');
          }
        });
      }
      ngDialog.openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: data,
          data: $scope.current_step,
          action: 'edit',
          isEditStepInProgress: true,
          propertyId : $scope.approvalStep.property.id || $scope.approvalStep.property
        }
      }).then(function (result) {
        $scope.current_step = result;
      });
    });

  };

  $scope.showAttachmentDialog = function (idAttachment) {
    var promises = [];
    var attachments = [];
    promises.push(AttachmentService.get(idAttachment, true).then(function (data) {
      attachments.push(data);
    }));
    $q.all(promises).then(function () {
      ngDialog.open({
        template: 'views/templates/dialog/attachment/list.html',
        controller: 'AttachmentListDialog',
        className: 'ngdialog-theme-default ngdialog-attachments-view',
        data: {
          attachments: attachments
        }
      });
    });
  };

  $scope.getFileObject = function (attachments, index) {
    if (attachments[index].document_file) {
      // Use authenticated method for document files
      FolderFileService.getFileObjectAuthenticated(attachments[index].document_file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].document_file.signed_view_url || attachments[index].document_file.secure_share_url || attachments[index].document_file.file);
        }
      });
    }
    else {
      // For external links or non-document files, use the old method
      FolderFileService.getFileObject(attachments[index].file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].signed_view_url || attachments[index].secure_share_url || attachments[index].file);
        }
      });
    }
  };

  $scope.openAttachmentDialog = function (attachments, index) {
    if (attachments[index].document_file) {
      $scope.getFileObject(attachments, index);
    }
    else if (attachments[index].link) {
      $window.open(attachments[index].link);
    }
    else {
      $scope.getFileObject(attachments, index);
    }
  };

  $scope.showAttachNoteFileDialog = function () {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      data: { task: {}, mode: 'upload_note' }
    }).then(function (attachments) {
      angular.forEach(attachments, function (attachment) {
        $scope.attachments_note.push(attachment);
      });
    });
  };

  $scope.removeAttachmentNote = function (index) {
    $scope.attachments_note.splice(index, 1);
  };

  $scope.openDynamicFormDialog = function (editable) {
    var request_filters = {for_approval: true};

    function handleTaskResolution(task) {
      TaskService.one(task.id).get(request_filters).then(function (task_obj) {
        const required_aproval_status_list = [TaskService.STATUS_APPROVAL_APPROVED];
        const can_resolve_approval = (
          task_obj.has_approval_config &&
          !required_aproval_status_list.includes(task_obj.status.toString())
        );
        let conflicts_promise = {};

        // NfD: This should be the usual case in this controller.
        if (can_resolve_approval) {
          conflicts_promise = TaskService.getSequenceApprovers(task_obj.id);
        }
        $q.when(conflicts_promise).then(function (conflicts) {
          if (!isEmpty(conflicts.results)) {
            // If need to resolve fallback approvers it process them
            // and returns to the next dialog.
            ngDialog.openConfirm({
              template: 'views/templates/dialog/task/resolve-conflicts.html',
              className: 'ngdialog-theme-default',
              controller: 'TaskResolveConflictsDialog',
              data: {
                task: task_obj,
                conflicts: conflicts.results
              }
            }).then(function(fallback_approvers) {
              ngDialog.open({
                template: 'views/templates/dialog/task/request-approval.html',
                className: 'ngdialog-theme-default',
                controller: 'TaskResolveDialog',
                data: {
                  task: task_obj,
                  fallback_approvers: fallback_approvers,
                }
              });
            });
          } else {
            ngDialog.open({
              template: 'views/templates/dialog/task/request-approval.html',
              className: 'ngdialog-theme-default',
              controller: 'TaskResolveDialog',
              data: {
                task: task_obj,
              }
            });
          }
        });
      });
    }

    function onDialogSuccess(dialog_result) {
      // Dialog result can be a "skip" string or the dynamic_form_data returned object
      const data = dialog_result.dynamic_form_data ? dialog_result.dynamic_form_data : dialog_result;
      // Don't trigger "submit for approval" if task is already in approval flow
      var isAlreadyInApproval = [TaskService.STATUS_APPROVAL_IN_PROGRESS].includes($scope.approvalStep.status.toString());
      
      // Reset dialog and in-progress tracking after successful submit
      $scope.openingDialog = false;
      $scope.dynamicFormInProgress = false;
      
      if (dialog_result !== "skip") {
        // Extract ID from data - handle various structures
        var dataId = (typeof data === 'object' && data !== null) ? data.id : data;
        // Only update if we got a valid ID (number or string), otherwise keep existing
        if (dataId && typeof dataId !== 'object') {
          $scope.approvalStep.dynamic_form_data = dataId;
        }
        if (!dialog_result.progress && !isAlreadyInApproval) {
          handleTaskResolution($scope.approvalStep);
        }
      }
      else if (!isAlreadyInApproval) {
        handleTaskResolution($scope.approvalStep);
      }
    }

    PropertyService.one($scope.approvalStep.property.id).get(request_filters).then(function (property) {
      var has_dynamic_form_data = !isNull($scope.approvalStep.dynamic_form_data);

      // Gets the DFD id if exists, else get DF id.
      var resource_id = has_dynamic_form_data ?
        $scope.approvalStep.dynamic_form_data.id || $scope.approvalStep.dynamic_form_data :
        $scope.approvalStep.dynamic_form.id || $scope.approvalStep.dynamic_form;

      // If the Dynamic Form does not contains Data (a DynamicFormData instance) it creates
      // using DynamicFormRestService
      var rest_service_handler = has_dynamic_form_data ?
        DynamicFormDataRestService :
        DynamicFormRestService;

      rest_service_handler.one(resource_id).get(request_filters).then(async function (resource_obj) {
        var dynamic_form_obj = has_dynamic_form_data ? resource_obj.dynamic_form : resource_obj;
        var dynamic_form_data_obj = has_dynamic_form_data ? resource_obj : null;
        var isApprovalInProgress = [TaskService.STATUS_APPROVAL_IN_PROGRESS].includes($scope.approvalStep.status.toString());

        // Check feature gate for Expo integration
        var useExpoIntegration = false;
        try {
          useExpoIntegration = await StatsigService.checkGate('envoy_dynamic_forms', {
            dynamic_form_id: dynamic_form_obj.id
          });
        } catch (error) {
          console.error('[openDynamicFormDialog] Failed to check feature gate:', error);
        }

        $scope.openingDialog = true;
        $scope.initialdata.onopen = true;

        DynamicFormProviderService.openForm({
          useExpoIntegration: useExpoIntegration,
          formObj: dynamic_form_obj,
          formDataObj: dynamic_form_data_obj,
          data: {
            task: editable ? $scope.approvalStep : {
              ...$scope.approvalStep,
              status: parseInt(TaskService.STATUS_SOLVED)
            },
            approvalStatus: isApprovalInProgress,
            showClose: !isApprovalInProgress,
            property: property,
            filters: request_filters,
            df_comments: $scope.data.text,
            attachments: $scope.attachments_note
          },
          closeCallback: function(result) {
            if (result && result !== 'skip') {
              onDialogSuccess(result);
            } else if (result === 'skip') {
              onDialogSuccess('skip');
            } else {
              onDialogClose(result);
            }
          }
        }).catch(function(error) {
          onDialogClose(error);
        });

        function onDialogClose(dialogdata) {
          $scope.openingDialog = false;
          if (dialogdata) {
            $timeout(function () {
              if(dialogdata.df_comments){
                 $scope.data.text = dialogdata.df_comments;
                 if (CKEDITOR.instances.text) {
                   CKEDITOR.instances.text.setData($scope.data.text);
                 }
              }
            }, 10);

            if (dialogdata.df_attachments_note && dialogdata.df_attachments_note.length > 0)
              $scope.attachments_note = angular.copy(dialogdata.df_attachments_note);
            
            // Track if form was modified but not submitted (Expo only)
            if (typeof dialogdata.formInProgress === 'boolean') {
              $scope.dynamicFormInProgress = dialogdata.formInProgress;
            }
          }
        }
      });
    });
  };

  const saveNote = function(actionitemapprovalstep_set, text, attachments) {
    const data = {
      "actionitemapprovalstep_set": [actionitemapprovalstep_set],
      "text": text,
      attachments
    }
    var promise = null;
    if (!isEmpty($scope.current_step.notes) && $scope.current_step.notes[0].id) {
      promise = NoteService.one($scope.current_step.notes[0].id).patch(data);
    } else {
      promise = NoteService.post(data);
    }
    return promise;
  }

  const saveAttachmentNote = function() {
    var attachments_note = [];
    const promises = []
    angular.forEach($scope.attachments_note, function (attachment) {
      if (attachment.id) {
        attachments_note.push(attachment.id);
      } else {
        if (attachment.document_folder || attachment.document_file) {
          promises.push(AttachmentService.linkTo(attachment).then(function (response) {
            attachments_note.push(response.data.id);
          }));
        }
        else if (attachment.link) {
          promises.push(AttachmentService.post(attachment.name, null, attachment.link, attachment.available_for_account).then(function (response) {
            attachments_note.push(response.data.id);
          }));
        }
        else {
          promises.push(AttachmentService.post(attachment.name, attachment.file, null, attachment.available_for_account).then(function (response) {
            attachments_note.push(response.data.id);
          }));
        }
      }
    });

    let defer = $q.defer();
    $q.all(promises).then(function () {
      defer.resolve(attachments_note);
    }, function() {
      defer.reject();
    });
    return defer.promise;

  }

  $scope.saveComments = function() {
    let defer = $q.defer();
    if ((isEmpty($scope.data.text) || placeholderNote.includes($scope.data.text)) && $scope.attachments_note.length === 0) {
      $scope.Form.$setSubmitted();
      $scope.data.text = '';
      FormErrorsService.goToError();
      defer.resolve();
    }
    else {
      saveAttachmentNote().then(function (attachments) {
        saveNote($scope.approvalStep.current_step.id, $scope.data.text, attachments).then(function(note) {
          ApprovalStepService.get($scope.approvalStep.current_step.id).then(function (step) {
            $scope.current_step = step;
            $scope.data.text = step.notes.length === 0 ? '' : step.notes[0].text;
            $scope.attachments_note = step.notes.length === 0 ? [] : step.notes[0].attachments;
          });
          $scope.initialdata.data = $scope.data.text
          defer.resolve(note);
        }, function () {
          defer.resolve();
        });
      }, function () {
        defer.resolve();
      });
    }
    return defer.promise
  }

  $scope.getData = function () {
    var defer = $q.defer();
    var data = angular.copy($scope.data);
    data['completed_date'] = moment().format('YYYY-MM-DD');

    if (data['text'] || $scope.attachments_note.length > 0) {
      if (!data['text']) {
        data['text'] = '';
      }
      $scope.saveComments().then(function (note) {
        data['note_added'] = true;
        $scope.notes.push(note);
        defer.resolve(data);
      }, function () {
        defer.resolve(data);
      });
    }
    else {
      defer.resolve(data)
    }
    return defer.promise;
  }

  $scope.toSubmit = function (request, revisiondata) {
    var defer = $q.defer();
    if ($scope.isLastStepIndex()) {
      if ($scope.approvalStep.dynamic_form_data) {
        var filters = { for_approval: true };
        var dfd = $scope.approvalStep.dynamic_form_data;
        // Handle different possible structures: number, string, or object with id
        var data_id = (typeof dfd === 'object' && dfd !== null) ? (dfd.id || dfd) : dfd;
        // If still an object, try to get a numeric value
        if (typeof data_id === 'object') {
          console.error('[toSubmit] Could not extract ID from dynamic_form_data:', dfd);
          defer.reject();
          return defer.promise;
        }
        DynamicFormDataRestService.one(data_id).get(filters).then(function (data) {
          // Open form if required AND (not valid OR still in progress - from API or local tracking)
          var isInProgress = data.in_progress || $scope.dynamicFormInProgress;
          var formNeedsCompletion = data.dynamic_form.required && (!data.valid || isInProgress) && $scope.canEditDF();
          if (formNeedsCompletion) {
            PropertyService.one($scope.approvalStep.property.id).get(filters).then(async function (property) {
              // Check feature gate for Expo integration
              var useExpoIntegration = false;
              try {
                useExpoIntegration = await StatsigService.checkGate('envoy_dynamic_forms', {
                  dynamic_form_id: data.dynamic_form.id
                });
              } catch (error) {
                console.error('[toSubmit] Failed to check feature gate:', error);
              }

              DynamicFormProviderService.openForm({
                useExpoIntegration: useExpoIntegration,
                formObj: data.dynamic_form,
                formDataObj: data,
                data: {
                  task: {
                    ...$scope.approvalStep,
                    status: parseInt(TaskService.STATUS_PENDING)
                  },
                  approvalStatus: true,
                  showClose: false,
                  property: property,
                  filters: filters,
                  df_comments: $scope.data.text,
                  attachments: $scope.attachments_note
                },
                closeCallback: function(result) {
                  // Reset in-progress tracking after successful submit
                  $scope.dynamicFormInProgress = false;
                  defer.resolve();
                }
              }).catch(function() {
                defer.reject();
              });
            });
          } else if (!data.dynamic_form.required || (data.valid && !isInProgress)) {
            defer.resolve();
          } else {
            defer.reject();
          }
        });
      } else {
        defer.resolve();
      }
    } else {
      defer.resolve();
    }
    $q.when(defer.promise).then(function () {
      $scope.isFromSubmit = true;
      $scope.getData().then(function (data) {
        if(revisiondata && revisiondata.fallback_notification_users &&  revisiondata.fallback_notification_users.length > 0) {
          data.fallback_notification_users = (revisiondata.fallback_notification_users).map(function(u){ return u.id ? u.id: parseInt(u, 10)});
        }
        data.noerror = revisiondata?.noerror;
        request(data).then(function (return_submitter_data) {
            if(return_submitter_data && return_submitter_data.report_to){
              $scope.openRevisionRequired(true, return_submitter_data.report_to);
            }
            else{
              $scope.goBack();
            }
          })
          .catch(function(ex) {
             if(ex.status == 400) {
              $scope.openRevisionRequired(true);
             }
          });
        });
    });
  }

  $scope.openRevisionRequired = function (showfallback, external_approver_report_to) {
    $scope.Form.$setSubmitted();
    if (isEmpty($scope.data.text) || $scope.data.text === placeholderNote) {
      $scope.data.text = '';
      FormErrorsService.goToError();
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    ngDialog.openConfirm({
      template: 'views/templates/dialog/property/revision-required.html',
      controller: 'RevisionRequiredDialog',
      data: {
        reviewed_steps: $scope.approvalStep.reviewed_steps,
        current_step: $scope.current_step,
        is_showfallback: showfallback,
        fallback_approvers: external_approver_report_to,
        property: $scope.approvalStep.property.id
      }
    }).then(function (result) {
      if (result.request_type === 'previous_step') {
        const requestRevision = function (data) {
          let defer = $q.defer();
          data['start_index'] = result.start_index;
          $scope.current_step.requestRevision(data).then(function (data_result) {
            AnalyticsService.track('Task Approval Revision Requested', { 
              ...AnalyticsService.getTaskGroupProperties($scope.taskGroupTrackingData),
            });
            defer.resolve(data_result);
          }, function (error) {
            defer.reject(error);
          });
          return defer.promise;
        }
        $scope.toSubmit(requestRevision);
      } else {
        const returnSubmitter = function (data) {
          let defer = $q.defer();
          $scope.current_step.returnSubmitter(data).then(function (data_result) {
            AnalyticsService.track('Task Approval Revision Requested', { 
              ...AnalyticsService.getTaskGroupProperties($scope.taskGroupTrackingData),
            });
            defer.resolve(data_result);
          }, function (error) {
            defer.reject(error);
          });
          return defer.promise;
        }
        result.noerror = true;
        $scope.toSubmit(returnSubmitter, result);
      }
    });
  };

  $scope.onApprove = function () {
    $scope.Form.$setSubmitted();
    if (isEmpty($scope.data.text) || $scope.data.text === placeholderNote) {
      $scope.data.text = '';
      FormErrorsService.goToError();
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    const approve = function (data) {
      let defer = $q.defer();
      $scope.current_step.approve(data).then(function () {
        AnalyticsService.track('Task Approval Completed', { 
          ...AnalyticsService.getTaskGroupProperties($scope.taskGroupTrackingData)
        });
        if ($scope.isLastStepIndex()) {
          let dataResolveTask = {
            attachment: [],
            completed_date: moment().format('YYYY-MM-DD'),
            status: "1"
          }
          TaskService.one($scope.approvalStep.id).resolveTaskForApproval(dataResolveTask).then(function (data_result) {
            AnalyticsService.track("Task Marked Complete", {
              ...AnalyticsService.getTaskGroupProperties(data_result),
              cannot_do : false,
              copy_supervisor : data.important || false,
              days_late : AnalyticsService.calculateDaysLate(data_result.due_date),  
            })
            if (data_result.workflow_status == 4 && data_result.can_launch_trigger_wfs) {
              $scope.launchWorkflow(data_result);
            }
            defer.resolve();
          }, function (error) {
            defer.reject(error);
          });
        } else {
          defer.resolve();
        }
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }
    $scope.toSubmit(approve);
  };

  $scope.onReject = function () {
    $scope.Form.$setSubmitted();
    if (isEmpty($scope.data.text) || $scope.data.text === placeholderNote) {
      $scope.data.text = '';
      FormErrorsService.goToError();
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    ngDialog.openConfirm({
      template: 'views/templates/dialog/property/task-approval-rejected.html',
    }).then(function () {
      const reject = function () {
        const apiRes = $scope.current_step.reject().then(function (data) {
          AnalyticsService.track('Task Approval Terminated', {
            ...AnalyticsService.getTaskGroupProperties($scope.taskGroupTrackingData),
          });
          return data;
        })
        return apiRes
      }
      $scope.toSubmit(reject);
    });
  };

  $scope.addNewNote = function () {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/task/add-note.html',
      controller: 'TaskAddNoteDialog',
      data: {task: angular.copy($scope.approvalStep)}
    }).then(function (note) {
      angular.forEach(note.attachments, function (attachment) {
        if (attachment.document_file) {
          attachment.file = attachment.document_file.signed_view_url;
        }
        else if (attachment.link) {
          attachment.file = attachment.link;
        }
      });
      $scope.approvalStep.notes.push(note);
    });
  };

  $scope.onRouteChangeOff = $scope.$on('$stateChangeStart', routeChange);

  function routeChange(event, newUrl, toParams) {
    if(CKEDITOR?.instances?.text?.commands?.maximize?.state==1){
      CKEDITOR?.instances?.text.execCommand( 'maximize' ) 
    }
    if($scope.isFromSubmit) { return }
    if (!$scope.changeText()) { return }
    event.preventDefault();
      if(!$scope.openPopup)
      {
        $scope.newState = newUrl
      }
    if(!$scope.openPopup && !(toParams['#']?.includes('ngdialog'))){
      $scope.openPopup=true;
      ngDialog.openConfirm({
        template: 'views/templates/dialog/template/review-confirm.html',
        preCloseCallback: function() {
          $scope.openPopup=false;
      }
      }).then(function (result) {
        if (result === 'ok') {
          $scope.saveComments().then(function (data) {
            $scope.openPopup=false;
            if(data){
              $scope.onRouteChangeOff();
              $state.go($scope.newState);
            }
          });
        }
      });
    }
  }

  $scope.goBack = function () {
    let curr;
    let state = angular.copy($state.current.name);
    let backState = BrowserHistoryService.getBackState();
    if (backState && backState !== 'login-redirection') {
      curr=true;
      $state.go(backState);
    } else {
      curr=true;
      $state.go('approvals');
    }
    $timeout(function () {
      if ($state.current.name === state && !curr) {
        $state.go('approvals');
      }
    }, 1500);
  };

  $scope.changeText=function(){
    if (!CKEDITOR.instances.text) {
      return false;
    }
    if($scope.data.text === placeholderNote){
      return ($scope.initialdata.data !== ((CKEDITOR.instances.text.getData()).trim()))
    }
    return ($scope.initialdata.data !== (CKEDITOR.instances.text.getData()))
    
  }

  $scope.initData();
  $scope.getSequenceSteps();

  $scope.$on('task-request-approval-dialog:success', function (event, task) {
    if (task.id === $scope.approvalStep.id) {
      TaskService.getApprovalReview($scope.approvalStep.id).then(function (approvalStep) {
        $scope.approvalStep = approvalStep;
        $scope.initData();
      });
    }
  });
};

app.controller('ApprovalTaskController', ['$window', '$scope', '$q', '$timeout', '$state', '$stateParams', '$filter', 'BrowserHistoryService',
  'approvalStepObj', 'AttachmentService', 'ngDialog', 'FilterService', 'PropertyService', 'ApprovalStepService',
  'NoteService', 'DynamicFormRestService', 'DynamicFormDataRestService', 'TaskService', 'NavigationService',
  'PermissionService', 'FolderFileService', 'FormErrorsService', 'NotificationService', 'AccountUserService', 'AnalyticsService',
  'StatsigService', 'DynamicFormProviderService', 'AuthDataService',
  ApprovalTaskController]);